import React, { useState } from "react";
import { BiSolidChevronDown } from "react-icons/bi";
import { Popover, Typography } from "@mui/material";

const DEFAULT_OPTIONS = [{ label: "Customer" }, { label: "Company" }];

const TypeSelector = ({
  activeTab,
  setActiveTab,
  options = DEFAULT_OPTIONS,
  placeholder = "Select Type",
  label,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "type-selector-popover" : undefined;
  const tabs =
    Array.isArray(options) && options.length ? options : DEFAULT_OPTIONS;

  return (
    <div className="flex flex-col px-0 gap-y-1">
      {label ? (
        <p className="text-sm font-bold text-main px-1">{label}</p>
      ) : null}
      <div
        className="relative text-left cursor-pointer transition-colors ease-in-out duration-200 border border-line hover:border-main bg-card text-ink px-4 py-3 rounded-lg font-quicksand font-bold text-sm flex gap-x-6 items-center active:scale-[.99]"
        onClick={handleClick}
      >
        <div className="flex items-center justify-between w-full">
          <div className="w-full outline-none text-left bg-transparent">
            {activeTab === "" ? placeholder : activeTab}
          </div>
          <BiSolidChevronDown
            className="text-[1.5rem] cursor-pointer text-muted"
            aria-describedby={id}
            variant="contained"
          />
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            border: "1px solid #E5E9EB",
            width: "100%",
            maxWidth: "320px",
            overflow: "hidden",
            marginTop: "10px",
            boxShadow:
              "0 10px 30px rgba(16,69,70,0.12), 0 2px 8px rgba(16,69,70,0.08)",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Typography
          sx={{
            p: 2,
            backgroundColor: "#ffffff",
            overflow: "hidden",
            borderRadius: "12px",
          }}
        >
          <div className="bg-card text-ink font-quicksand flex flex-col justify-center items-center rounded-lg">
            <div className="w-full flex flex-col justify-between gap-y-3 items-start">
              {tabs.map((tab) => (
                <div
                  key={tab.label}
                  className="flex gap-x-3 items-center cursor-pointer hover:bg-subtle rounded-lg px-2 py-1 transition-colors w-full"
                  onClick={() => {
                    setActiveTab(tab.label);
                    handleClose();
                  }}
                >
                  <input
                    type="checkbox"
                    className="mr-1 h-4 w-4 rounded border border-line accent-main"
                    checked={activeTab === tab.label}
                    readOnly
                    onChange={() => {}}
                  />
                  <span>{tab.label}</span>
                </div>
              ))}
            </div>
          </div>
        </Typography>
      </Popover>
    </div>
  );
};

export default TypeSelector;
